export default {"src":"/_next/static/media/us-flag-icon.1d62d66b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};